import { IdmClientContext } from "@sista/idm-client";
import { useContext } from "react";
/**
 * Je přihlášený účet administrátorem TAČR?
 *
 * Mazání a obnova jmenných prostorů a historie změn textů jsou dostupné výhradně jemu,
 * a to nezávisle na permissions správy textů - endpoint /config/permissions o adminovi
 * nic nevrací, příznak je pouze na účtu z IdM.
 */
export const useIsAdmin = () => {
    const { loggedAccount } = useContext(IdmClientContext);
    return loggedAccount?.admin === true;
};
